import React from "react";
import "./market.scss";
import { Link } from "react-router-dom";

const Market = () => {
  return (
    <>
      <section className="rain-markets">
        <div className="custom-container">
          <div className="allcards">
            <Link to="/apps/rain-trade">
              <div className="cardone">
                <div className="inercard">
                  <img src="\assets\app\raintrade.png" className="coinimg" />
                  <img src="\assets\rainshadowtoken.png" className="shadowimg" />
                  <h3>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.99994 15.3333C6.99804 15.3332 6.01928 15.0322 5.19054 14.4691C4.36181 13.9061 3.72134 13.1071 3.35217 12.1757C2.983 11.2443 2.90216 10.2234 3.12013 9.24555C3.3381 8.26765 3.84482 7.37778 4.57461 6.69133C5.46927 5.84933 7.66661 4.33333 7.33327 1C11.3333 3.66667 13.3333 6.33333 9.33327 10.3333C9.99994 10.3333 10.9999 10.3333 12.6666 8.68666C12.8466 9.202 12.9999 9.756 12.9999 10.3333C12.9999 11.6594 12.4732 12.9312 11.5355 13.8689C10.5978 14.8065 9.32602 15.3333 7.99994 15.3333Z"
                        fill="white"
                      />
                    </svg>
                    Trending
                  </h3>
                </div>
                <div className="bottom-card">
                  <h4>Prediction Markets</h4>
                  <h5>Rain Trade</h5>
                  <h6>
                    Rain Trade is a prediction market application powered by the Rain Protocol.
                  </h6>
                </div>
              </div>
            </Link>
             <div className="cardone">
              <div className="inercard">
                <img src="\assets\app\current.png" className="coinimg" />
                {/* <img src="\assets\rainthree.png" className="shadowimg" /> */}
                

              </div>
              <div className="bottom-card third">
                <h4>Prediction Markets</h4>
                <h5>Currents</h5>
                <h6>
                  The future of prediction markets
                </h6>
              </div>
            </div>
            <div className="cardone">
              <div className="inercard ">
                <img src="\assets\crds.png" className="coinimg" />
                <img src="\assets\shades.png" className="shadowimg" />
                
              </div>
              <div className="bottom-card second">
                <h4>Social Trading</h4>
                <h5>Speed Markets</h5>
                <h6>
                  Experience rapid-fire markets with instant resolutions
                </h6>
              </div>
            </div>
            <Link to="/apps/pred">
              <div className="cardone">
                <div className="inercard">
                  <img src="\assets\raintoken.png" className="coinimg" />
                  <img src="\assets\rainshadowtoken.png" className="shadowimg" />
                </div>
                <div className="bottom-card">
                  <h4>Prediction Markets</h4>
                  <h5>Pred</h5>
                  <h6>
                    The ultimate marketplace for prediction markets built on Rain Protocol
                  </h6>
                </div>
              </div>
            </Link>

            {/* <Link to="/apps/risk-market" >
              <div className="cardone">
                <div className="inercard">
                  <img src="\assets\app\riskmarket.png" className="coinimg" />

                </div>
                <div className="bottom-card second">
                  <h4>Social Trading</h4>
                  <h5>Risk Markets</h5>
                  <h6>
                    A high-speed trading experience built around perfect timing
                  </h6>
                </div>
              </div>
            </Link>
            <Link to="/apps/black-jack">
              <div className="cardone">
                <div className="inercard">
                  <img src="\assets\cardthree.png" className="coinimg" />
                  <img src="\assets\rainthree.png" className="shadowimg" />
                </div>
                <div className="bottom-card second">
                  <h4>Social Trading</h4>
                  <h5>Blackjack Markets</h5>
                  <h6>
                   First ever blackjack prediction game. Fast round, real money, no house edge.
                  </h6>
                </div>
              </div>
            </Link> */}
           
            
            {/* <div className="cardone">
              <div className="inercard ">
                <img src="\assets\cardfive.png" className="coinimg" />
                <img src="\assets\rainsix.png" className="shadowimg" />
                <h3>
                  {" "}

                  COMING SOON
                </h3>
              </div>
              <div className="bottom-card fifth">
                <h4>Aether Forecasts</h4>
                <h5>Aether Forecasts</h5>
                <h6>
                  Fusce volutpat lectus et nisl consectetur finibus. In vitae scelerisque augue...
                </h6>
              </div>
            </div>
            <div className="cardone">
              <div className="inercard ">
                <img src="\assets\cardsix.png" className="coinimg" />
                <img src="\assets\rainsix.png" className="shadowimg" />
                <h3>
                  COMING SOON
                </h3>
              </div>
              <div className="bottom-card fifth">
                <h4>Tempest Markets</h4>
                <h5>Tempest Markets</h5>
                <h6>
                  Maecenas dignissim justo eget nulla rutrum molestie. Maecenas lobortis sem...
                </h6>
              </div>
            </div> */}

          </div>
        </div>
      </section>
    </>
  );
};

export default Market;
